import FormSectionContainer from "../../components/Form/FormSectionContainer";
import FormSectionTitle from "../../components/styled/FormSectionTitle";
import { useGetAllCarInfoByCarInfoTypeSlug } from "../../utils/carInfo.utils";

export default function ImporterInfoField({ watch, control, errors, setValue }) {
  const { data: forwardCompany, loading } = useGetAllCarInfoByCarInfoTypeSlug("company");
  const fields = [
    {
      label: "Name",
      name: "importer.name",
      type: "text",
      placeholder: "Name",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Mobile",
      name: "importer.mobile",
      type: "text",
      placeholder: "Mobile",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Designation",
      name: "importer.designation",
      type: "text",
      placeholder: "Designation",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Company",
      name: "importer.company",
      type: "select",
      placeholder: "Company",
      col: { md: 4, lg: 3 },
      options: forwardCompany
    }
  ];

  const isLoading = loading;

  return (
    <FormSectionContainer
      setValue={setValue}
      fields={fields}
      control={control}
      watch={watch}
      errors={errors}
      loading={isLoading}>
      <div className="col-12">
        <FormSectionTitle>Importer / Sender Information</FormSectionTitle>
      </div>
    </FormSectionContainer>
  );
}
